// Generated by genversion.
module.exports = '5.0.0'
